import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/*
 * In Angular, prop names cannot start with 'on'.
 * To keep with Stencil conventions, prop names beginning with
 * 'on' will be replaced with prefix 'ds'.
 */
import { ReplaySubject } from 'rxjs';
import { LightThemeProvider } from '@platform-ui/design-system';
import * as ReactDOM from 'react-dom';
import * as React from 'react';
import camelCase from 'lodash.camelcase';
import kebabCase from 'lodash.kebabcase';
/* When DOM nodes are moved around.
 * - HTMLElement: new parent.
 * - null: return to original parent.
 * - "unmount": Cancel subscription.
 */

export var Slots;

(function (Slots) {
  Slots["header"] = "header$";
  Slots["body"] = "body$";
  Slots["footer"] = "footer$";
})(Slots || (Slots = {}));

export var Mounts;

(function (Mounts) {
  Mounts["div"] = "div";
  Mounts["span"] = "span";
})(Mounts || (Mounts = {}));

export var GenericWCWrapper = /*#__PURE__*/function (_HTMLElement) {
  _inherits(GenericWCWrapper, _HTMLElement);

  var _super = _createSuper(GenericWCWrapper);

  _createClass(GenericWCWrapper, [{
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(attrName, _, newValue) {
      var _this$comp, _this$comp$__docgenIn, _this$comp$__docgenIn2, _this$comp$__docgenIn3;

      var propName = camelCase(attrName);
      var isBooleanAttr = ((_this$comp = this.comp) === null || _this$comp === void 0 ? void 0 : (_this$comp$__docgenIn = _this$comp.__docgenInfo) === null || _this$comp$__docgenIn === void 0 ? void 0 : (_this$comp$__docgenIn2 = _this$comp$__docgenIn.props[propName]) === null || _this$comp$__docgenIn2 === void 0 ? void 0 : (_this$comp$__docgenIn3 = _this$comp$__docgenIn2.type) === null || _this$comp$__docgenIn3 === void 0 ? void 0 : _this$comp$__docgenIn3.name) === 'boolean';

      if (isBooleanAttr) {
        this[propName] = [null, undefined].indexOf(newValue) === -1;
      } else {
        this[propName] = newValue;
      }
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      var _this$_props;

      return (_this$_props = this._props) === null || _this$_props === void 0 ? void 0 : _this$_props.map(function (prop) {
        return kebabCase(prop);
      });
    }
  }]);

  function GenericWCWrapper(comp) {
    var _this;

    _classCallCheck(this, GenericWCWrapper);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "comp", void 0);

    _defineProperty(_assertThisInitialized(_this), "slotName", void 0);

    _defineProperty(_assertThisInitialized(_this), "parentName", void 0);

    _defineProperty(_assertThisInitialized(_this), "mountEl", void 0);

    _defineProperty(_assertThisInitialized(_this), "sub$", void 0);

    _defineProperty(_assertThisInitialized(_this), "mount", void 0);

    _defineProperty(_assertThisInitialized(_this), "header$", void 0);

    _defineProperty(_assertThisInitialized(_this), "body$", void 0);

    _defineProperty(_assertThisInitialized(_this), "footer$", void 0);

    _defineProperty(_assertThisInitialized(_this), "props", {
      getHeaderSlot: function getHeaderSlot(node) {
        _this.header$.next(node);
      },
      getBodySlot: function getBodySlot(node) {
        _this.body$.next(node);
      },
      getFooterSlot: function getFooterSlot(node) {
        _this.footer$.next(node);
      }
    });

    _this.comp = comp;

    if (_this.comp) {
      // @ts-ignore
      var propKeys = ['key'].concat(_toConsumableArray(Object.keys(comp.__docgenInfo.props)));
      propKeys.map(function (prop) {
        Object.defineProperty(_assertThisInitialized(_this), prop, {
          get: function get() {
            return this.props[prop];
          },
          set: function set(newValue) {
            /* This short-circuit is necessary for
             * Angular Forms support for TypeAhead.
             */
            if (this.tagName === 'DS-TYPE-AHEAD' && prop === 'dsOnChange' && newValue === undefined) {
              return;
            }

            this.props[prop] = newValue;
            this.render();
          }
        });
      });
    }

    return _this;
  }

  _createClass(GenericWCWrapper, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      if (!this.mount || !this.comp) {
        return;
      }

      var children = Array.from(this.children || this.childNodes || []) // @ts-ignore
      .map(function (child) {
        return child.elem;
      }).filter(Boolean);
      var renderAsync = this.tagName === 'DS-MODAL-ACTIONS';

      if (renderAsync) {
        window.setTimeout(function () {
          ReactDOM.render( /*#__PURE__*/React.createElement(LightThemeProvider, null, React.createElement.apply(React, [_this2.comp, _this2.props].concat(_toConsumableArray(children)))), _this2.mount);
        }, 0);
      } else {
        ReactDOM.render( /*#__PURE__*/React.createElement(LightThemeProvider, null, React.createElement.apply(React, [this.comp, this.props].concat(_toConsumableArray(children)))), this.mount);
      }
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this$parentElement,
          _this3 = this;

      this.header$ = new ReplaySubject();
      this.body$ = new ReplaySubject();
      this.footer$ = new ReplaySubject();
      this.mount = document.createElement(this.mountEl || 'span');
      this.appendChild(this.mount);
      this.render();
      this.style.display = 'none';
      var parentElement = this.parentElement;

      if (!this.sub$ && ((_this$parentElement = this.parentElement) === null || _this$parentElement === void 0 ? void 0 : _this$parentElement.constructor.name) === this.parentName && this.slotName) {
        this.sub$ = parentElement[this.slotName].asObservable().subscribe(function (node) {
          switch (node) {
            case 'unmount':
              {
                _this3.sub$.unsubscribe();

                delete _this3.sub$;
                break;
              }

            case null:
              {
                parentElement.appendChild(_this3);
                _this3.style.display = 'none';
                break;
              }

            default:
              {
                node.appendChild(_this3);
                _this3.style.display = '';
              }
          }
        });
      } else {
        this.style.display = '';
      }
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var _this$parentElement2;

      ReactDOM.unmountComponentAtNode(this.mount);

      if (this.contains(this.mount)) {
        this.removeChild(this.mount);
      } else if ((_this$parentElement2 = this.parentElement) === null || _this$parentElement2 === void 0 ? void 0 : _this$parentElement2.contains(this.mount)) {
        this.parentElement.removeChild(this.mount);
      }

      if (!document.body.contains(this)) {
        this.header$.next('unmount');
        this.body$.next('unmount');
        this.footer$.next('unmount');
      }

      delete this.mount;
    }
  }]);

  return GenericWCWrapper;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

_defineProperty(GenericWCWrapper, "_props", void 0);

export var ChildElement = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(ChildElement, _HTMLElement2);

  var _super2 = _createSuper(ChildElement);

  _createClass(ChildElement, [{
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(attrName, _, newValue) {
      var _this$component, _this$component$__doc, _this$component$__doc2, _this$component$__doc3;

      var propName = camelCase(attrName);
      var isBooleanAttr = ((_this$component = this.component) === null || _this$component === void 0 ? void 0 : (_this$component$__doc = _this$component.__docgenInfo) === null || _this$component$__doc === void 0 ? void 0 : (_this$component$__doc2 = _this$component$__doc.props[propName]) === null || _this$component$__doc2 === void 0 ? void 0 : (_this$component$__doc3 = _this$component$__doc2.type) === null || _this$component$__doc3 === void 0 ? void 0 : _this$component$__doc3.name) === 'boolean';

      if (isBooleanAttr) {
        this[propName] = [null, undefined].indexOf(newValue) === -1;
      } else {
        this[propName] = newValue;
      }
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      var _this$_props2;

      return (_this$_props2 = this._props) === null || _this$_props2 === void 0 ? void 0 : _this$_props2.map(function (prop) {
        return kebabCase(prop);
      });
    }
  }]);

  function ChildElement(props) {
    var _this4;

    _classCallCheck(this, ChildElement);

    _this4 = _super2.call(this);

    _defineProperty(_assertThisInitialized(_this4), "component", void 0);

    _defineProperty(_assertThisInitialized(_this4), "parentName", void 0);

    _defineProperty(_assertThisInitialized(_this4), "elem", void 0);

    _defineProperty(_assertThisInitialized(_this4), "props", {});

    var propKeys = ['key'].concat(_toConsumableArray(Object.keys(props)));
    propKeys.map(function (prop) {
      Object.defineProperty(_assertThisInitialized(_this4), prop, {
        get: function get() {
          return this.props[prop];
        },
        set: function set(newValue) {
          this.props[prop] = newValue;
          this.render();
        }
      });
    });
    return _this4;
  }

  _createClass(ChildElement, [{
    key: "render",
    value: function render() {
      var children = Array.from(this.children) // @ts-ignore
      .map(function (child) {
        return child.elem;
      }).filter(Boolean);
      this.elem = React.createElement.apply(React, [this.component, this.props].concat(_toConsumableArray(children)));
      this.parentElement.render();
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      this.render();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      if (this.parentElement.constructor.name === this.parentName) {
        this.parentElement.render();
      }
    }
  }]);

  return ChildElement;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

_defineProperty(ChildElement, "_props", void 0);

export var TextChildElement = /*#__PURE__*/function (_HTMLElement3) {
  _inherits(TextChildElement, _HTMLElement3);

  var _super3 = _createSuper(TextChildElement);

  _createClass(TextChildElement, [{
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(attrName, _, newValue) {
      var _this$component2, _this$component2$__do, _this$component2$__do2, _this$component2$__do3;

      var propName = camelCase(attrName);
      var isBooleanAttr = ((_this$component2 = this.component) === null || _this$component2 === void 0 ? void 0 : (_this$component2$__do = _this$component2.__docgenInfo) === null || _this$component2$__do === void 0 ? void 0 : (_this$component2$__do2 = _this$component2$__do.props[propName]) === null || _this$component2$__do2 === void 0 ? void 0 : (_this$component2$__do3 = _this$component2$__do2.type) === null || _this$component2$__do3 === void 0 ? void 0 : _this$component2$__do3.name) === 'boolean';

      if (isBooleanAttr) {
        this[propName] = [null, undefined].indexOf(newValue) === -1;
      } else {
        this[propName] = newValue;
      }
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      var _this$_props3;

      return (_this$_props3 = this._props) === null || _this$_props3 === void 0 ? void 0 : _this$_props3.map(function (prop) {
        return kebabCase(prop);
      });
    }
  }]);

  function TextChildElement(props) {
    var _this5;

    _classCallCheck(this, TextChildElement);

    _this5 = _super3.call(this); // @ts-ignore

    _defineProperty(_assertThisInitialized(_this5), "component", void 0);

    _defineProperty(_assertThisInitialized(_this5), "elem", void 0);

    _defineProperty(_assertThisInitialized(_this5), "props", {});

    ['key'].concat(_toConsumableArray(Object.keys(props))).map(function (prop) {
      Object.defineProperty(_assertThisInitialized(_this5), prop, {
        get: function get() {
          return this.props[prop];
        },
        set: function set(newValue) {
          this.props[prop] = newValue;
          this.render();
        }
      });
    });
    return _this5;
  }

  _createClass(TextChildElement, [{
    key: "render",
    value: function render() {
      var _this6 = this;

      window.setTimeout(function () {
        _this6.elem = /*#__PURE__*/React.createElement(_this6.component, _this6.props, _this6.innerText);

        _this6.parentElement.render();
      });
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      this.style.display = 'none';
      this.render();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      delete this.elem;

      if (!document.body.contains(this)) {
        return;
      }

      this.parentElement.render();
    }
  }]);

  return TextChildElement;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

_defineProperty(TextChildElement, "_props", void 0);
//# sourceMappingURL=utils.js.map